import {
    GET_SALE_RETURN_REGION_STATE_REPORT_CUSTOMER_ERROR,
    GET_SALE_RETURN_REGION_STATE_REPORT_CUSTOMER_REQUEST,
    GET_SALE_RETURN_REGION_STATE_REPORT_CUSTOMER_SUCCESS,
} from "../actions/types";

export const getSaleOmsReturnCustomer = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {

        case GET_SALE_RETURN_REGION_STATE_REPORT_CUSTOMER_REQUEST:
            return {
                loading: true,
            };
        case GET_SALE_RETURN_REGION_STATE_REPORT_CUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_SALE_RETURN_REGION_STATE_REPORT_CUSTOMER_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}